import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { FiscalDocumentIssuerData } from "../types/fiscalDocumentIssuer.type";

type UseCompanyBranchWithFiscalDocumentIssuerDataType = (props: {
  companyBranchId?: string;
}) => UseQueryResult<FiscalDocumentIssuerData, unknown>;

const useCompanyBranchWithFiscalDocumentIssuerData: UseCompanyBranchWithFiscalDocumentIssuerDataType = ({ companyBranchId }) => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: FiscalDocumentIssuerData; }; }, unknown, FiscalDocumentIssuerData>({
    enabled: !!companyBranchId,
    queryKey: ['companyBranchWithFiscalDocument', companyBranchId],
    queryFn: () => {
      return privateAxios.get(`/client/company_branches/${companyBranchId}/with_fiscal_document_issuer_data`);
    },
    select: (data) => data?.data?.data,
  });
};

export default useCompanyBranchWithFiscalDocumentIssuerData;
